import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { placeholderImg } from "../constants/files";

const Image = ({src, style, alt, className}) => {
    return (
        <>
            <LazyLoadImage
                id="lazy-image"
                alt={alt}
                className={className}
                wrapperClassName={className}
                effect="blur"
                src={src}
                placeholderSrc={placeholderImg}
                width="100%"
                height={'auto'}
                style={{...style}}
            />
        </>
    );
}

export default Image;